import { configure, makeAutoObservable } from "mobx";
import io from "socket.io-client";
// import { TimelineMax, TweenLite, Linear } from "gsap";

configure({
  enforceActions: "observed"
})

class PollStore {
  isLoading = false;
  polls = {};
  poll = [];
  options = [];
  optionsName = "";
  id = 0;
  name = "";
  socket = false;
  error = false;

  constructor() {
    makeAutoObservable(this);
  }

  pollSocketDisconnect() {
    this.socket.disconnect();
  }

  pollSocketConnect(pollID) {
    this.setIsLoading(true);
    this.id = pollID;
    this.socket = io(process.env.REACT_APP_POLL_SERVICE_URI, {
      query: `id=${pollID}`,
      withCredentials: false,
    });

    console.log(process.env.REACT_APP_POLL_SERVICE_URI)

    this.socket.on("error", error => {
      console.log("error", error);
      this.setError(error);
    });

    this.socket.on("connect_error", error => {
      console.log("connect_error", error);
      this.setError(error);
    });

    this.socket.on("pollResult", data => {
      const poll = data;
      this.setPoll(poll);
      this.setError(false);

      this.socket.on("polls", data => {
        //'polls' is a misnomer. A single poll is fetched by its id and returned.
        this.setError(false);
        const poll = data;
        this.setPoll(poll);
      });


      this.socket.emit("getData", this.id);
      this.setIsLoading(false);
    });
  }

  setIsLoading = boolean => {
    this.isLoading = boolean;
  }

  setError = error => {
    this.error = error;
  }

  setPoll = poll => {
    this.poll = poll;
    this.options = poll.options;
    this.id = poll.id;
    this.name = poll.name;
  }
}

export default new PollStore();
